// First-touch attribution capture. Persists UTM/fbclid/referrer/landing page so it
// survives navigation until the lead is submitted. Never overwrites first-touch.
const KEY = "pp_attribution";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureAttribution() {
  try {
    const existing = JSON.parse(localStorage.getItem(KEY) || "null");
    const params = new URLSearchParams(window.location.search);
    const incoming = {};
    UTM_KEYS.forEach((k) => { if (params.get(k)) incoming[k] = params.get(k); });
    if (params.get("fbclid")) incoming.fbclid = params.get("fbclid");
    if (params.get("gclid")) incoming.gclid = params.get("gclid");
    if (params.get("campaign")) incoming.campaign = params.get("campaign");
    if (params.get("ad_id")) incoming.ad_id = params.get("ad_id");
    if (params.get("ad_set_id") || params.get("adset_id")) incoming.ad_set_id = params.get("ad_set_id") || params.get("adset_id");

    // First-touch wins: only set if we have no stored attribution yet.
    if (existing && Object.keys(existing).length) return existing;

    const record = {
      ...incoming,
      utm_source: incoming.utm_source || incoming.campaign || undefined,
      landing_page: window.location.pathname + window.location.search,
      referrer: document.referrer || undefined,
      captured_at: new Date().toISOString(),
    };
    localStorage.setItem(KEY, JSON.stringify(record));
    return record;
  } catch {
    return {};
  }
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}
